/* @flow */

export default {
  fieldset: {
    margin: 0,
    padding: 0,

    border: 'none',
  },
  checkbox: {
    marginTop: 40,
  },
};
